import styled from 'styled-components';

export const BooleanBoxDiv = styled.div`
  .option-button:first-child {
    margin-right: 0.5rem;
  }
`;
